/**
 * Imperial CMS — English visitor-facing translations.
 *
 * Mirrors `pl.ts` structure (shape constrained by `MessagesShape` type).
 */

import type { MessagesShape } from "./pl";

export const messagesEn: MessagesShape = {
  maintenance: {
    title: "One moment",
    subtitle: "We're working on this section",
    body: "We'll be back shortly. The page will refresh automatically.",
    footnote: "Thank you for your patience.",
  },

  serviceDisabled: {
    title: "Site under maintenance",
    subtitle: "Service currently unavailable",
    body: "We apologize for the inconvenience. Please come back in a moment — the page will refresh automatically.",
    footnote: "Thank you for your patience.",
  },

  notFound: {
    title: "Not found",
    body: "The address you're looking for doesn't exist or has been moved.",
    homeLink: "Back to homepage",
  },

  loginRequired: {
    title: "Content available after signing in",
    body: "You must be signed in to view this page. After signing in you'll be returned right here.",
    loginButton: "Sign in",
    homeLink: "Back to homepage",
  },

  globalLoginGate: {
    title: "Sign in required",
    message: "You must sign in to access the content of this site.",
    loginLabel: "Login or e-mail",
    passwordLabel: "Password",
    submit: "Sign in",
    submitting: "Signing in...",
    failed: "Invalid login or password.",
  },

  homepage: {
    backendErrorTitle: "Backend communication error",
    redirectLoopTitle: "Homepage configuration error",
    redirectLoopMessage:
      "The homepage is currently unavailable due to a misconfigured redirect — " +
      "the specified URL points back to the homepage, creating a redirect loop.",
    redirectLoopHint: "Please contact the site administrator.",
    bootstrapErrorHint:
      "The homepage was not rendered because the backend returned an error. " +
      "No content was lost - fix the cause above and reload the page.",
  },

  backendOutage: {
    maintenanceTitle: "System update in progress",
    maintenanceBody: "We are rolling out a new version of the site. It will be back in a few minutes.",
    unavailableTitle: "Service temporarily unavailable",
    unavailableBody: "We cannot reach the server right now. We are working on it.",
    maintenanceAction: "A system update is in progress. Please try again in a few minutes.",
    unavailableAction: "The service is temporarily unavailable. Please try again shortly.",
    errorTitle: "Something went wrong",
    errorBody: "This page could not be displayed.",
    autoRefresh: "The page will refresh automatically.",
    retry: "Try again",
    footnote: "Thank you for your patience.",
  },

  common: {
    readDocs: "Read documentation ->",
    paginationNext: "Next ->",
  },
};
